import { useField } from 'formik';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

const useStyles = makeStyles(() => ({
	lightBackground: {
		color: 'black',
	},
}));

const TextAreaInputField = ({ label, className, lightBackground, onChangeCallBack, ...props }) => {
	const classes = useStyles();

	// useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
	// which we can spread on <input> and alse replace ErrorMessage entirely.
	const [field, meta] = useField(props);

	const handleOnChangeCallBack = (event) => {
		const value_ = event.target.value;
		// setValue(value_);
		console.log('MyTextAreaInput handleOnChangeCallBack', value_);
		onChangeCallBack && onChangeCallBack(value_);
	};
	const { id, name } = props;
	return (
		<div className={`control ${className}`}>
			{label && <label htmlFor={id || name}>{label}</label>}
			<textarea
				rows="10"
				placeholder="Small textarea"
				className={`input input-textfield textarea ${
					lightBackground && classes.lightBackground
				}`}
				{...field}
				{...props}
				onChange={handleOnChangeCallBack}
			/>
			{meta.touched && meta.error ? <div className="error">{meta.error}</div> : null}
		</div>
	);
};

TextAreaInputField.propTypes = {
	id: PropTypes.string,
	name: PropTypes.string,
	label: PropTypes.string,
	lightBackground: PropTypes.bool,
	onChangeCallBack: PropTypes.func,
	className: PropTypes.string,
};

export default TextAreaInputField;
